module.exports = __webpack_public_path__ + "img/109-5f20ea.png";